import { render, staticRenderFns } from "./SuppliersComponent.vue?vue&type=template&id=c4d649f8&"
import script from "./SuppliersComponent.vue?vue&type=script&lang=js&"
export * from "./SuppliersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports